/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {SearchConfig as ɵd} from './src/components/global-search-overlay/global-search-overlay-config';
export {SearchOverlayRef as ɵc} from './src/components/global-search-overlay/global-search-overlay-ref';
export {SEARCH_CONFIG as ɵb} from './src/components/global-search-overlay/global-search-overlay-token';
export {GlobalSearchOverlayService as ɵa} from './src/services/global-search-overlay.service';